import { Capacitor } from '@capacitor/core';

const APP_UA_TAG = 'MyTownlyDriverApp';

export const isAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua) && (/\bwv\b/i.test(ua) || ua.includes(APP_UA_TAG));
};

export const isNativeDriverShell = () => {
  if (typeof window !== 'undefined') {
    if (window.__MYTOWNLY_DRIVER_NATIVE__ === true) return true;
    if (window.__MYTOWNLY_RIDES_NATIVE__ === true) return true;
  }
  return isAndroidWebView();
};

export const isNativeApp = () => {
  try {
    if (Capacitor.isNativePlatform()) return true;
    const platform = Capacitor.getPlatform?.();
    if (platform === 'android' || platform === 'ios') return true;
  } catch {
    /* not in Capacitor */
  }
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) return true;
  return isNativeDriverShell();
};

export const shouldUseNativePhoneAuth = () => {
  if (isNativeApp()) return true;
  if (isNativeDriverShell()) return true;
  try {
    const platform = Capacitor.getPlatform();
    if (platform === 'android' || platform === 'ios') return true;
  } catch {
    /* Capacitor unavailable */
  }
  return false;
};

export const useNativePhoneAuth = shouldUseNativePhoneAuth;
